const translations = {
  "en": {
    "Automatic renewal:": "Automatic renewal:",
    "Expiry Date:": "Expiry Date:",
    "Included in your plan": "Included in your plan",
    "Off": "Off",
    "On": "On",
    "one-time": "one-time",
    "per %{var0}": "per %{var0}",
    "Renewal date:": "Renewal date:"
  },
  "zh-tw": {
    "Automatic renewal:": "自動續訂：",
    "Expiry Date:": "到期日：",
    "Included in your plan": "你的方案包含的內容",
    "Off": "關閉",
    "On": "開啟",
    "one-time": "一次性的",
    "per %{var0}": "每 %{var0}",
    "Renewal date:": "更新日期："
  }
};

export default translations;
